import React from 'react';
import { Icon } from 'react-feather';
interface GridButtonProps {
  Icon: Icon;
  onClick: () => void;
  buttonText: string;
}

const GridButton: React.FC<GridButtonProps> = ({ Icon, onClick, buttonText }) => {
  return (
    <div className="grid-btn" onClick={onClick}>
      <Icon />
      <br />
      {buttonText}
    </div>
  );
};

export default GridButton;